<template>
  <div class="myAccount">
    <div class="topbar">
      <i @click="goHome"></i>
      <!-- <span>{{$t('nav_name')}}</span> -->
      <div class="mainBox1">
        <div class="changeLangBtn" @click.stop="moreLang()">
          {{ $t("language") }}
          <em class="iconfont icon-een"></em>
          <ul
            v-show="changeLangBox"
            class="chooseLangUl"
          >
            <li
              v-for="(item, index) in langList"
              class="chooseLangUlli"
              :key="index"
              @click="setLanguage(item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="settingBtn" @click.stop="setting()">
          {{ $t("myaccount_title") }}
          <em class="iconfont icon-een"></em>
          <ul v-show="settingBoxVis" class="chooseLangUl chooseLangUls">
            <li @click="goHome">{{ $t("myHome") }}</li>
            <li @click="race">{{ $t("myPageTitle") }}</li>
            <li @click="logOut">{{ $t("setting_2") }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="banner">
      <div class="forget">
        <div class="Title">{{ $t("myaccount_title") }}</div>

        <div class="inputItem btns">
          <div class="avatorBox">
            <img :src="userAvator.url" width="120" height="120" />
          </div>

          <button class="MAbtn" @click="(modifyAvatorShow = true), getAvator()">
            <span>{{ $t("modify_avator") }}</span>
          </button>
        </div>

        <div class="inputItem clearfix">
          <span class="account">{{ $t("signup_txt2") }}</span>
          <input
            type="text"
            v-model.trim="temp.name"
            @blur="checkName"
            @focus="checkName1"
          />
          <span v-show="show2" class="s1">{{ $t("signup_note8") }}</span>
        </div>

        <div class="inputItem schoolItem clearfix">
          <span class="account" style="zIndex:120">
            {{ $t("schoolName") }}
          </span>
          <el-select
            class="classGrade"
            v-model="temp.schoolName"
            @change="changeSchool"
            :filter-method="changeSchoolFilter"
            filterable
            remote
          >
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :label="item.schoolCnName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <span v-show="show10" class="s1">{{ $t("signup_note9") }}</span>
        </div>

        <div class="inputItem clearfix">
          <span class="account" style="margin-right:20px;">
            {{ $t("signup_txt3") }}
          </span>
          <div class="classGrade" style="paddingLeft:159px;">
            <select class="input11" v-model="temp.grade" @change="checkGrade">
              <option value style="display: none">
                {{ $t("signup_note9") }}
              </option>
              <option value="0">{{ $t("grade0") }}</option>
              <option value="1">{{ $t("grade1") }}</option>
              <option value="2">{{ $t("grade2") }}</option>
              <option value="3">{{ $t("grade3") }}</option>
              <option value="4">{{ $t("grade4") }}</option>
              <option value="5">{{ $t("grade5") }}</option>
              <option value="6">{{ $t("grade6") }}</option>
              <option value="7">{{ $t("grade7") }}</option>
              <option value="8">{{ $t("grade8") }}</option>
              <option value="9">{{ $t("grade9") }}</option>
              <option value="10">{{ $t("grade10") }}</option>
              <option value="11">{{ $t("grade11") }}</option>
              <option value="12">{{ $t("grade12") }}</option>
              <option value="13">{{ $t("grade13") }}</option>
            </select>
          </div>
          <span v-show="show9" class="s1">{{ $t("signup_note9") }}</span>
        </div>

        <div class="inputItem clearfix">
          <span class="account">{{ $t("signup_txt12") }}</span>

          <input
            v-model.trim="temp.email"
            type="text"
            style="cursor: not-allowed;background:rgba(277,277,277,.85)"
            disabled
            @blur="checkEmail"
            @focus="checkEmail1"
          />
          <span v-show="show8" class="s1">{{ $t("signup_note16") }}</span>
        </div>

        <div class="btns">
          <button class="MAbtn" @click="modifyPsdShow = true">
            {{ $t("modifyPwd_button") }}
          </button>

          <button class="MAbtn" @click="sucess">
            {{ $t("myaccount_button") }}
          </button>
        </div>

        <div class="send" v-show="allMsg" v-text="warinningText"></div>
      </div>
    </div>

    <el-dialog
      class="modify_dialog"
      :visible.sync="modifyPsdShow"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="container">
        <div class="container-box">
          <div class="closebtn" @click="modifyPsdShow = false"></div>
          <h3>{{ $t("modifyPwd_button") }}</h3>

          <div class="detailBox detailBoxInput">
            <section>
              <el-input
                v-model.trim="modify_input.ori"
                class="detailBox-input"
                :placeholder="this.$t('modifyPsd_1')"
                :type="showPsd1 === false ? 'password' : 'text'"
              >
                <i
                  class="el-icon-view el-input__icon"
                  slot="suffix"
                  @click="showPsd1 = !showPsd1"
                >
                </i>
              </el-input>
            </section>
            <section>
              <el-input
                v-model.trim="modify_input.new"
                class="detailBox-input"
                :placeholder="this.$t('modifyPsd_2')"
                :type="showPsd2 === false ? 'password' : 'text'"
              >
                <i
                  class="el-icon-view el-input__icon"
                  slot="suffix"
                  @click="showPsd2 = !showPsd2"
                >
                </i>
              </el-input>
            </section>
            <section>
              <el-input
                v-model.trim="modify_input.newA"
                class="detailBox-input"
                :placeholder="this.$t('modifyPsd_3')"
                :type="showPsd3 === false ? 'password' : 'text'"
              >
                <i
                  class="el-icon-view el-input__icon"
                  slot="suffix"
                  @click="showPsd3 = !showPsd3"
                >
                </i>
              </el-input>
            </section>
          </div>
        </div>

        <div class="modifybtns">
          <button class="btn" @click="modifyPsdShow = false">
            {{ $t("com_cancel") }}
          </button>
          <button class="btn" @click="updatePassword">
            {{ $t("com_confirm") }}
          </button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      class="modify_dialog"
      :visible.sync="modifyAvatorShow"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="container">
        <i class="closebtn" @click="modifyAvatorShow = false"></i>

        <div class="container-box">
          <h3>{{ $t("modify_Avator") }}</h3>

          <div class="detailBox detailBoxImg">
            <div
              class="imgCover"
              :class="{
                selected: avatorSelect.url == item.url,
                coverLock: item.usable == 0,
              }"
              v-for="item in avatorList"
              :key="item.id"
            >
              <div class="tag">
                <span>{{ item.picExplain }}</span>
              </div>
              <i class="locked" v-if="item.usable == 0" />
              <i class="lockIcon" v-if="item.usable == 0" />
              <img
                :src="item.url"
                width="120"
                height="120"
                @click="setImg(item.id, item.url)"
              />
              <i v-if="avatorSelect.url == item.url" class="coner coner-lt"></i>
              <i v-if="avatorSelect.url == item.url" class="coner coner-rt"></i>
              <i v-if="avatorSelect.url == item.url" class="coner coner-rb"></i>
              <i v-if="avatorSelect.url == item.url" class="coner coner-lb"></i>
            </div>
          </div>
        </div>

        <div class="modifybtns">
          <button class="btn" @click="modifyAvatorShow = false">
            {{ $t("com_cancel") }}
          </button>
          <button class="btn" @click="updateAvator">
            {{ $t("com_confirm") }}
          </button>
        </div>
      </div>
    </el-dialog>

    <LEAPPOPUP
      v-show="maskBox"
      @onOK="logOut"
      :title="$t('timeout01')"
      :content="$t('timeout02')"
      :cancelButtonTxt="$t('timeout04')"
      :okButtonTxt="$t('timeout03')"
      :isConfirm="false"
    ></LEAPPOPUP>
  </div>
</template>

<script>
import md5 from "js-md5";
import Cookies from "js-cookie";
import store from "../store";
import { mapGetters } from "vuex";
import MediaUtils from "@/utils/MediaUtils";
import LeapPopup from "./LeapPopup.vue";
import I18nUtils from "@/utils/i18nUtils";

export default {
  data() {
    return {
      show2: false,
      show2Reg: false,
      show3: false,
      show3Reg: false,
      show8: false,
      show8Reg: false,
      show9: false,
      show9Reg: false,
      show10: false,
      warinningText: "",
      allMsg: false,
      temp: {
        name: "",
        grade: "",
        schoolId: "",
        schoolName: "",
        phone: "",
        email: "",
        token: "",
      },
      schoolList: [],
      changeLangBox: false,
      langList: I18nUtils.langList,
      settingBoxVis: false,

      showPsd1: false,
      showPsd2: false,
      showPsd3: false,
      modifyPsdShow: false,
      modify_input: {
        ori: "",
        new: "",
        newA: "",
      },
      modifyAvatorShow: false,
      // 全部头像
      avatorList: [],
      avatorSelect: {},
    };
  },

  components: {
    LEAPPOPUP: LeapPopup,
  },

  mounted() {
    I18nUtils.initLanguage(this);

    this.getUserInfo();
    this.avatorSelect = this.userAvator;
  },

  methods: {
    setLanguage(lang) {
      I18nUtils.updateDivLanguage(lang);
      I18nUtils.setLanguage(this, lang);
    },

    updatePassword() {
      if (
        this.modify_input.ori == "" ||
        this.modify_input.new == "" ||
        this.modify_input.newA == ""
      ) {
        this.$message.error("密码输入栏不可为空");
        return;
      }

      let reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/;
      if (!reg.test(this.modify_input.ori)) {
        this.$message.error(
          this.$t("signup_note2")
        );
        return;
      }

      if (!reg.test(this.modify_input.new)) {
        this.$message.error(
          this.$t("signup_note2")
        );
        return;
      }

      if (this.modify_input.new !== this.modify_input.newA) {
        this.$message.error(this.$t("signup_note3"));
        return;
      }

      this.$http
        .getAxios("user/updatePassword", {
          method: "get",
          params: {
            oldPassword: md5(this.modify_input.ori),
            password: md5(this.modify_input.new),
          },
        })
        .then((res) => {
          const _res = res.data;
          if (_res.code == 0) {
            this.modifyPsdShow = false;

            this.modify_input.ori = "";
            this.modify_input.new = "";
            this.modify_input.newA = "";
            this.$message.success(this.$t("modifyPsd_success"));
          } else if (_res.code == 14) {
            this.$message.error(this.$t("modifyPsd_oriPsdError"));
          } else {
            this.$notify.error({
              title: "Error",
              message:
                this.$t("modifyPsd_failed") + ", " + "Code:" + _res.code,
            });
          }
        });
    },
    async getAvator() {
      try {
        await this.$http.getAxios.get("/user/getAllPicture").then((res) => {
          const _res = res.data;

          if (_res.code == 0) {
            this.avatorList = _res.data;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    setImg(val, val2) {
      this.avatorSelect = {
        id: val,
        url: val2,
      };
    },
    async updateAvator() {
      try {
        await this.$http.getAxios
          .get("/user/setPicture", {
            params: {
              id: this.avatorSelect.id,
            },
          })
          .then((res) => {
            const _res = res.data;
            if (_res.code == 0) {
              this.$store.commit("saveUserAvator", this.avatorSelect);
              this.modifyAvatorShow = false;
              this.$message.success(this.$t("modifyAvator_success"));
              this.$forceUpdate();
            } else {
              this.$message.error(
                this.$t("modifyAvator_failed") + ", Code:" + _res.code
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    },

    changeSchool(e) {
      let force = false;
      this.schoolList.forEach((item) => {
        if (item.id == e) {
          this.temp.schoolId = item.id;
          this.temp.schoolName = item.schoolCnName;
          force = true;
          console.log("schoolName", e, this.temp.schoolName);
          return;
        }
        if (!force) {
          this.temp.schoolId = 0;
        }
        this.$forceUpdate();
      });
    },
    changeSchoolFilter(queryString) {
      if (queryString == null || queryString == "") {
        return;
      } else {
        this.$http
          .getAxios("/mobile/querySchoolMsg", {
            method: "get",
            params: {
              schoolName: queryString,
            },
          })
          .then((res) => {
            const _res = res.data;

            if (_res.code == "0") {
              if (!!!_res.data) {
                this.schoolList = [];
                return;
              }
              this.schoolList = _res.data;
            }
          });
      }
    },

    goHome() {
      this.$router.push({ path: "/index" });
    },

    setting() {
      this.settingBoxVis = !this.settingBoxVis;
      this.changeLangBox = false;
    },
    race() {
      this.$router.push({ path: "/myPage" });
    },
    logOut() {
      this.$http
        .getAxios("/user/logout", {
          method: "post",
        })
        .then((res) => {
          var res = res.data;
          if (res.code == "0") {
            store.commit("toggleMaskState", false);
            localStorage.clear();
            this.$router.push({ path: "/" });
          }
        });
    },

    checkEmail() {
      let reg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      );
      if (reg.test(this.temp.email)) {
        this.show8 = false;
        this.show8Reg = true;
      } else {
        this.show8 = true;
        this.show8Reg = false;
      }
    },
    checkEmail1() {
      this.show8 = true;
    },
    checkGrade() {
      this.show9 = false;
    },
    checkName() {
      if (this.temp.name != "") {
        this.show2 = false;
        this.show2Reg = true;
      } else {
        this.show2 = true;
        this.show2Reg = false;
      }
    },
    checkName1() {
      this.show2 = true;
    },

    sucess() {
      if (this.temp.grade == "") {
        this.show9 = true;
        return;
      }
      // this.schoolList.forEach(item => {
      //   if (item.id == this.temp.schoolId) {
      //     this.temp.schoolName = item.schoolCnName ? item.schoolCnName : "";
      //   }
      // });

      if (this.temp.name != "" && this.temp.grade != "") {
        this.show10 = false;
        var userArea = "";
        if (this.$i18n.locale == "zh") {
          userArea = "1";
        } else if (this.$i18n.locale == "en") {
          userArea = "2";
        } else if (this.$i18n.locale == "sp") {
          userArea = "3";
        } else if (this.$i18n.locale == "fr") {
          userArea = "4";
        }
        this.$http
          .getAxios("/sms/updateMyAccountMsg ", {
            method: "post",
            data: {
              firstName: this.temp.name,
              lastName: this.temp.surname,
              grade: this.temp.grade,
              schoolName: this.temp.schoolId,
              userArea: userArea,
              grade: this.temp.grade,
            },
          })
          .then((res) => {
            if (res.data.code == "0") {
              localStorage.setItem("competeObj", JSON.stringify(res.data.data));
              this.$router.push({ path: "/index" });
            } else if (res.data.code == "100") {
              this.warinningText = this.$t("bad_errorMsg1");
              this.allMsg = true;
            } else if (res.data.code == "99") {
              this.warinningText = this.$t("bad_errorMsg2");
              this.allMsg = true;
            } else {
              this.warinningText = this.$t("bad_network");
              this.allMsg = true;
            }
          })
          .catch((e) => {
            this.warinningText = this.$t("bad_network");
            this.allMsg = true;
            console.log(e);
          });
      } else if (!this.show2Reg) {
        this.show2 = true;
        this.show2Reg = false;
      } else if (!this.show8Reg) {
        this.show8 = true;
        this.show8Reg = false;
      }
    },

    getUserInfo() {
      this.$http.getAxios.post("/user/queryUserInfo").then((res) => {
        const _res = res.data;

        if (_res.code == "0") {
          localStorage.setItem("signIn", "1");

          this.temp.name = _res.data.firstName;
          this.temp.grade = _res.data.grade;
          this.temp.schoolName = _res.data.schoolName;
          this.temp.phone = _res.data.mobile;
          this.temp.schoolId = _res.data.schoolId;
          this.token = _res.data.token;

          if (_res.data.mobile != "") {
            this.temp.email = _res.data.mobile;
          } else if (_res.data.userAccount != "") {
            this.temp.email = _res.data.userAccount;
          } else {
            this.temp.email = _res.data.email;
          }
        } else {
          this.$router.push({ path: "/signIn" });
        }
      });
    },

    moreLang() {
      this.changeLangBox = !this.changeLangBox;
    },

  },

  computed: {
    ...mapGetters(["maskBox", "userAvator"]),
    lan() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style lang="scss">
.myAccount .topbar {
  width: 100%;
  height: 60px;
  color: #aaf9fe;
  background: #122346;
  i {
    position: absolute;
    top: 8px;
    left: 40px;
    width: 172px;
    height: 46px;
    cursor: pointer;
    z-index: 9999;
    background: url("~@/assets/images/bigIcon.png") no-repeat center;
  }
  span {
    font-size: 20px;
    line-height: 60px;
    margin-left: 100px;
  }

  .mainBox1 {
    height: 60px;
    position: absolute;
    top: 0;
    right: 20px;
    z-index: 323223;

    .settingBtn,
    .changeLangBtn {
      cursor: pointer;
      float: right;
      font-weight: normal;
      font-size: 18px;
      padding-right: 20px;
    }

    .settingBtn {
      padding-right: 0px;
      margin-right: 20px;
      line-height: 60px;
      text-align: center;
      position: relative;
      min-width: 150px;

      .chooseLangUl {
        position: absolute;
        z-index: 111;
        li {
          height: 40px;
          cursor: pointer;
        }
      }
      .chooseLangUls {
        width: 100%;
        background: #0c355c;
        padding: 0 5px 10px 5px;
        border-radius: 5px;
      }
    }

    .changeLangBtn {
      cursor: pointer;
      float: right;
      font-weight: normal;
      font-size: 18px;
      line-height: 60px;
    }
  }
}

.myAccount .banner {
  display: flex;
  align-items: center;
  justify-content: center;

  .forget {
    margin: 4rem 0;
    text-align: center;
  }

  .inputItem {
    margin-top: 40px;
    position: relative;
    margin-bottom: 34px;

    input {
      width: 320px;
      padding-left: 154px;
      height: 56px;
      background-color: #ffffff;
      box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
      border-radius: 8px;
      line-height: 56px;
      font-size: 16px;
      border: 0;
      text-indent: 20px;
      direction: ltr;
    }

    .classGrade {
      padding-left: 159px;
      height: 56px;
      background-color: #ffffff;
      -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
      box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
      border-radius: 8px;
      line-height: 56px;
      font-size: 16px;
      width: 315px;
      select {
        width: 100%;
        height: 100%;
        outline: none;
        border-radius: 8px;
        border: none;
        padding-left: 10px;
      }
    }

    .s1 {
      position: absolute;
      left: 20px;
      bottom: -26px;
      font-size: 14px;
      color: red;
    }

    .account {
      width: 142px;
      height: 33px;
      position: absolute;
      top: 11px;
      line-height: 33px;
      left: 0px;
      font-size: 16px;
      color: #010101;
      border-right: 1px solid #999999;
    }
  }

  .schoolItem {
    input {
      width: 315px;
      height: 50px;
      padding: 0;
      box-shadow: unset;
      border-right: 10px;
    }
  }

  .Title {
    line-height: 50px;
    background: url("~@/assets/images/title.png") center / cover no-repeat;
    font-size: 34px;
    font-weight: 700;
    color: #34f0f0;
  }

  .avatorBox {
    margin-left: 30px;
    img {
      border: 3px solid #0ff;
    }
  }

  .btns {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 120px;
  }

  .MAbtn {
    width: 180px;
    height: 60px;
    line-height: 60px;
    font-size: 20px;
    background-color: #2d8c9e;
    color: #fff;
    border: 0;
    border-radius: 30px;
    cursor: pointer;
  }

  .send {
    font-size: 20px;
    color: #ff5a00;
    margin-top: 39px;
  }
}

.myAccount .modify_dialog {
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    position: relative;
    width: 100%;
    min-width: 600px;
    height: 554px;
    background: url("~@/assets/images/modifyPsdbg.png");
    background-size: 100% 100%;

    .closebtn {
      position: absolute;
      right: 30px;
      width: 48px;
      height: 48px;
      background: url("~@/assets/images/modifyPsdbtn.png");
      background-size: 100% 100%;
      cursor: pointer;
    }

    &-box {
      position: absolute;
      margin-top: 40px;
      width: 100%;
      min-width: 600px;
      text-align: center;
      color: #fff;

      h3 {
        font-size: 28px;
        margin-bottom: 50px;
      }

      .detailBox {
        height: 300px;

        &-input {
          width: 400px;
          margin: 20px 100px;

          > .el-input__inner {
            height: 55px;
            line-height: 55px;
            font-size: 16px;

            &::placeholder {
              color: #333;
              font-size: 16px;
            }
          }
        }

        .switchBtn {
          width: 375px;

          .detail {
            box-sizing: border-box;
            width: 100%;
            height: 140px;
            margin: 5px 0;
            border: 1px solid #0e9eca;
            cursor: pointer;
            border-radius: 5px;
            transition: 0.3s ease all;

            &-Title {
              font-weight: bold;
              font-size: 28px;
              margin: 28px 20px;
            }
            &-desc {
              font-size: 20px;
            }
          }

          .active {
            background: #0e9eca;
            color: #fff;
            border: 1px solid #fff;
          }
        }
      }

      .detailBoxInput {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      .detailBoxImg {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        overflow-x: hidden;
        overflow-y: auto;

        .imgCover {
          position: relative;
          margin: 5px 6px;

          &:hover {
            .tag {
              opacity: 1;
            }
          }

          .tag {
            position: absolute;
            top: 2px;
            left: 2px;
            width: 120px;
            height: 40px;
            line-height: 40px;
            background: rgba(0, 0, 0, 0.5);
            z-index: 12;
            opacity: 0;
            transition: 0.4s ease all;
          }

          img {
            position: relative;
            display: block;
            border: 2px solid #fff;
            cursor: pointer;
          }
        }

        .selected {
          position: relative;
          img {
            border: 2px solid #0ff;
          }
          .coner {
            border: solid;
            width: 1.25vw;
            height: 1.25vw;
            position: absolute;
            border-color: #0fff;
          }
          .coner-lt {
            left: -1px;
            top: -1px;
            border-width: 2px 0 0 2px;
          }
          .coner-rt {
            right: -2px;
            top: -2px;
            border-width: 2px 2px 0 0;
          }
          .coner-rb {
            right: -1px;
            bottom: -1px;
            border-width: 0 2px 2px 0;
          }
          .coner-lb {
            left: -2px;
            bottom: -2px;
            border-width: 0 0 2px 2px;
          }
        }

        .coverLock {
          cursor: not-allowed;
        }
        .locked {
          position: absolute;
          width: 125px;
          height: 125px;
          background-color: rgba(0, 0, 0, 0.5);
          left: 0;
          right: 0;
          z-index: 10;
        }
        .lockIcon {
          position: absolute;
          width: 30px;
          height: 30px;
          background: url("~@/assets/images/modifyUserAvatorblock.png") center /
            contain no-repeat;
          transform: translate(85%, 300%);
          z-index: 11;
        }
      }
    }

    .modifybtns {
      position: absolute;
      left: 0;
      bottom: 50px;
      width: 80%;
      margin: 0 10%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .btn {
        width: 150px;
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        background-color: #2d8c9e;
        color: #fff;
        border: 0;
        border-radius: 30px;
        cursor: pointer;
      }
    }
  }
  .el-dialog {
    box-shadow: unset;
    margin: 0 !important;
    background: transparent !important;

    &__header {
      padding: 0;
    }

    &__body {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 85vh;
      color: unset;
      padding: unset;
    }
  }
}

.detailBox-input {
  direction: ltr;
}

</style>



// WEBPACK FOOTER //
// src/components/myAccount.vue